export default __webpack_public_path__ + "static/media/solidity.589a9cd9.svg";